export default {"src":"/_next/static/media/bg_standart_2.ce66b140.svg","height":38,"width":204,"blurWidth":0,"blurHeight":0};